<div class="update-refresh-container  popup-container center">
  <h2 mat-dialog-title>{{data.title | async}}</h2>
  <div  mat-dialog-actions>
    <button mat-button (click)="updateApp()">{{ data.refreshButton | async }}</button>
  </div>
</div>
